<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center1"><span class="big3">LUCK</span></p>
<p class="center"><span class="big"><strong>THE ESSENTIAL GUIDE</strong></span></p>
<p class="center2"><strong>THE SOCIETY FOR FORTUITOUS EVENTS</strong><br/><span class="small"><strong>DEBORAH AARONSON AND KEVIN KWAN, TRUSTEES</strong></span></p>
<p class="center"><img alt="" src="OEBPS/images/9780062046086_L06.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062046086_epub_tp_r1.vue?8e448718